import React from "react";
import { Button, Grid, Modal } from "@mui/material";
import { Box } from "@mui/system";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { modalStyle } from "../constants";

const AdminAddedModal = ({
  modalOpen,
  handleClose,
  title,
  adminData,
}) => {
  return (
    <Modal open={modalOpen} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Grid>
          <AccountCircleOutlinedIcon
            style={{ color: "#8E2DE2", width: 50, height: 50 }}
          />
        </Grid>
        <span style={{ color: "#313137", fontSize: 20, fontWeight: 600 }}>
          {title}
        </span>
        <Grid container>
          <span
            style={{
              color: "#000000",
              fontSize: 15,
              fontWeight: 500,
              marginTop: 30,
              marginBottom: 30,
            }}
          >
            Congratulations! {adminData.name} has been successfully added as{" "}
            {adminData.role}. We have sent them a new invite email.
          </span>
        </Grid>
        <Button
          fullWidth
          variant="contained"
          onClick={handleClose}
          style={{
            width: "200px",
            textTransform: "none",
            height: 55,
            fontSize: 15,
            fontWeight: 600,
            background: "#C84B96",
            color: "#FFFFFF",
          }}
        >
          Okay
        </Button>
      </Box>
    </Modal>
  );
};

export default AdminAddedModal;
